/**
 * Single source of truth for browser-visible environment configuration.
 *
 * Before this existed, `process.env.REACT_APP_*` was read inline at five
 * separate call sites. That meant the build tool's name for a variable
 * was hard-coded into five feature files, so swapping the build tool
 * (SEC-12 / SEC-25, CRA -> Vite) had to touch all five. Reading them in
 * one place keeps that coupling in one file.
 *
 * Everything here ships to the browser in plain text. Only ever put
 * public/publishable keys in this file — never a secret. The private
 * halves of these pairs (RECAPTCHA_SECRET, STRIPE_SECRET_KEY) live in
 * server/.env and must stay there.
 *
 * Vite only exposes variables prefixed `VITE_`; anything else in
 * client/.env is deliberately withheld from the bundle.
 */

/**
 * Google reCAPTCHA v2 site key. Pairs with RECAPTCHA_SECRET on the
 * server. When empty the widget does not render and forms submit
 * without a token — which is also the state during pre-rendering.
 */
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';

/**
 * Stripe publishable key. Pairs with STRIPE_SECRET_KEY on the server.
 * Empty means checkout cannot initialise, so CheckoutPage degrades to
 * its error state rather than throwing.
 */
export const STRIPE_PUBLISHABLE_KEY =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
